import texts from '../config/texts.json';

export const getTexts = (section = null) => {
  if (section) {
    return texts[section] || {};
  }
  return texts;
};

export const getUniqueValues = (array, key) => {
  return [...new Set(array.map((item) => item[key]))].filter(Boolean);
};

export const filterData = (data, filters) => {
  return data.filter((item) =>
    Object.entries(filters).every(([key, value]) => {
      if (value === 'all' || value === undefined || value === null) return true;
      if (Array.isArray(value)) {
        return value.length === 0 || value.includes(item[key]);
      }
      return item[key] === value;
    })
  );
};

export const sortData = (data, sortConfig) => {
  if (!sortConfig?.key) return data;
  const { key, direction } = sortConfig;
  const multiplier = direction === 'asc' ? 1 : -1;

  return [...data].sort((a, b) => {
    const aVal = a[key];
    const bVal = b[key];
    if (aVal == null) return 1;
    if (bVal == null) return -1;
    if (typeof aVal === 'number' && typeof bVal === 'number') {
      return (aVal - bVal) * multiplier;
    }
    return String(aVal).localeCompare(String(bVal)) * multiplier;
  });
};

export default {
  getTexts,
  getUniqueValues,
  filterData,
  sortData
};
